/**
 * 2021 Tax Year Rules
 * Combines federal and state rules
 */

import { TaxRules } from '../../types';
import { cashMedicalSupportLevelsIA2021 } from './IA/cashMedicalSupportLevels';
import { childSupportLevelsIA2021 } from './IA/childSupportLevels';

export const taxRules2021: TaxRules = {
    year: 2021,
    federal: {
        filing: {
            single: {
                standardDeduction: 12550,
                over65Deduction: 1750,
                blindDeduction: 1750,
                brackets: [
                    { minimumIncome: 0, maximumIncome: 9950.99, rate: 0.10 },
                    { minimumIncome: 9951, maximumIncome: 40525.99, rate: 0.12 },
                    { minimumIncome: 40526, maximumIncome: 86375.99, rate: 0.22 },
                    { minimumIncome: 86376, maximumIncome: 164925.99, rate: 0.24 },
                    { minimumIncome: 164926, maximumIncome: 209425.99, rate: 0.32 },
                    { minimumIncome: 209426, maximumIncome: 523600.99, rate: 0.35 },
                    { minimumIncome: 523601, rate: 0.37 },
                ],
            },
            marriedFilingSeparately: {
                standardDeduction: 12550,
                over65Deduction: 1400,
                blindDeduction: 1400,
                brackets: [
                    { minimumIncome: 0, maximumIncome: 9950.99, rate: 0.10 },
                    { minimumIncome: 9951, maximumIncome: 40525.99, rate: 0.12 },
                    { minimumIncome: 40526, maximumIncome: 86375.99, rate: 0.22 },
                    { minimumIncome: 86376, maximumIncome: 164925.99, rate: 0.24 },
                    { minimumIncome: 164926, maximumIncome: 209425.99, rate: 0.32 },
                    { minimumIncome: 209426, maximumIncome: 314150.99, rate: 0.35 },
                    { minimumIncome: 314151, rate: 0.37 },
                ],
            },
            headOfHousehold: {
                standardDeduction: 18800,
                over65Deduction: 1750,
                blindDeduction: 1750,
                brackets: [
                    { minimumIncome: 0, maximumIncome: 14200.99, rate: 0.10 },
                    { minimumIncome: 14201, maximumIncome: 54200.99, rate: 0.12 },
                    { minimumIncome: 54201, maximumIncome: 86350.99, rate: 0.22 },
                    { minimumIncome: 86351, maximumIncome: 164900.99, rate: 0.24 },
                    { minimumIncome: 164901, maximumIncome: 209400.99, rate: 0.32 },
                    { minimumIncome: 209401, maximumIncome: 523600.99, rate: 0.35 },
                    { minimumIncome: 523601, rate: 0.37 },
                ],
            },
        },
        fica: {
            regularSocialSecurityRate: 6.2,
            seSocialSecurityRate: 12.4,
            regularMedicareRate: 1.45,
            seMedicareRate: 2.9,
            additionalMedicareTaxRate: 0.90,
            socialSecurityThreshold: 142800,
            additionalMedicareTaxThreshold: 200000,
        },
        credits: {
            federalCreditPerDependentUnder17: 2000,
            federalRefundableAmountPerChildUnder17: 1400,
            federalCreditPerDependent17Over: 500,
            childTaxCreditPhaseOutThreshold: 200000,
            phaseOutAmountPerChild: 50,
            dollarAbovePhaseoutThresholdIncrement: 1000,
        },
        qbi: {
            thresholdStart: 164925,
            thresholdEnd: 999_999_999_999,
            tentativeRate: 999_999_999,
            thresholdRate: 2.5,
        },
        earnedIncome: {
            threshold: 2500,
            agiMultiplier: 15, // as percentage
        },
        dependentCare: {
            limitOneDependent: 3000,
            limitTwoOrMoreDependents: 6000,
        }
    },
    states: {
        IA: {
            // Iowa state tax - progressive brackets for 2021 (9 brackets)
            standardDeductionSingle: 2130,
            standardDeductionMarriedFilingSeparately: 2130,
            standardDeductionHeadOfHousehold: 5240,
            over65Deduction: 20,
            blindDeduction: 20,
            brackets: [
                { minimumIncome: 0, maximumIncome: 1676.99, rate: 0.0033 },
                { minimumIncome: 1677, maximumIncome: 3352.99, rate: 0.0067 },
                { minimumIncome: 3353, maximumIncome: 6704.99, rate: 0.0225 },
                { minimumIncome: 6705, maximumIncome: 15084.99, rate: 0.0414 },
                { minimumIncome: 15085, maximumIncome: 25140.99, rate: 0.0563 },
                { minimumIncome: 25141, maximumIncome: 33520.99, rate: 0.0596 },
                { minimumIncome: 33521, maximumIncome: 50280.99, rate: 0.0625 },
                { minimumIncome: 50281, maximumIncome: 75420.99, rate: 0.0744 },
                { minimumIncome: 75421, rate: 0.0853 },
            ],
            personalCredit: {
                single: 40,
                marriedFilingSeparately: 40,
                headOfHousehold: 80,
                perDependent: 40,
            },
            qadd: [
                { count: 0, rate: 0.00, minimum: 0 },
                { count: 1, rate: 0.08, minimum: 9_600 },
                { count: 2, rate: 0.12, minimum: 14_400 },
                { count: 3, rate: 0.14, minimum: 16_800 },
                { count: 4, rate: 0.15, minimum: 18_000 },
                { count: 5, rate: 0.16, minimum: 19_200 },
            ],
            support: {
                childSupport: childSupportLevelsIA2021,
                cashMedicalSupport: cashMedicalSupportLevelsIA2021,
            },
        },
    }
};
